import React from "react"
import { graphql } from "gatsby"
import { Check, Download } from "../../icons"
import parse from "html-react-parser"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"

const AvailableFacility = ({ facilities, title, stands, seats, buttons }) => {
  return (
    <section className="available-facility" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
      <div className="available-facility__inner">
        <div className='available-facility__wrapper'>
          <div className="available-facility__features">
            {title && <h2>{parse(title)}</h2>}
            {
              facilities &&
              <ul>
                {
                  facilities.map((el, i) => (
                    <li key={i}><span><Check /></span> {el.title}</li>
                  ))
                }
              </ul>
            }
          </div>

          <div className="available-facility__button">
            <ul>
              {stands && <li>stands <br/> [Total]<span>{stands}</span></li>}
              {seats && <li>Seats <br/> [Total]<span>{seats}</span></li>}
            </ul>

            <div className="available-facility__items">
              {
                buttons?.length > 0 && buttons[0].link?.length > 0 && buttons?.map((button, i) => (
                  <Link
                    key={i}
                    className={`btn ${i === 0 ? "btn--umber" : "btn--border"}`}
                    to={button.link[0]?.externalLink ? button.link[0].externalLink : button.link[0].internalLink.permalink}>
                    {button.title}
                    {button.title === 'Events Pack' && <Download/>}
                  </Link>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AvailableFacility

export const query = graphql`
  fragment AvailableFacilityProps on DatoCmsAvailableFacility {
    ... on DatoCmsAvailableFacility {
      id
      title
      stands
      seats
      facilities {
        title
      }
      buttons {
        ...LinkWithTitleProps
      }
    }
  }
`